// extracted by mini-css-extract-plugin
export default {"h1":"style_h1__qr8aN","h2":"style_h2__lZ3Vh","header":"style_header__SECc4"};